var $ = require('jquery');
'use strict';

var PLUGIN_NAME = 'radioselectIterateCheck';

var	DEFAULTS = {
	radioSelector: '',
	labelSelector: '',
	labelCheckedClass: ''
};

var RadioselectIterateCheck = function (selector, options) {
	this.$t = $(selector);
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;
	this.initialise_();
};

RadioselectIterateCheck.prototype.initialise_ = function() {
	if (this.options.radioSelector) {
		this.initCheckedRadioGroups_();
		this.bindInputEvent_();
	}
};

RadioselectIterateCheck.prototype.bindInputEvent_ = function() {
	var self_ = this;
	this.$t.on('click', this.options.radioSelector, function(event) {
		self_.performCheck_(event.currentTarget);
	});
};

RadioselectIterateCheck.prototype.initCheckedRadioGroups_ = function() {
	var checked = $(this.options.radioSelector + '[checked]', this.$t);
	if (checked.size() == 1) {
		this.performCheck_(checked[0]);
	}
};

RadioselectIterateCheck.prototype.performCheck_ = function(input) {
	var index = $(this.options.radioSelector, this.$t).index(input);

	$(this.options.labelSelector, this.$t).removeClass(this.options.labelCheckedClass);
	$(this.options.labelSelector+':lt('+index+')', this.$t).addClass(this.options.labelCheckedClass);
};

/**
 * decide, which methods will be "public"
 */
var API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new RadioselectIterateCheck(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.radioselect-iterate-check.js